"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 4.4a7.6 7.6 0 1 0 7.428 5.985.7.7 0 1 1 1.369-.296 9 9 0 1 1-6.88-6.884.7.7 0 0 1-.297 1.368A7.6 7.6 0 0 0 12 4.4",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.25 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m5.5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.24 12.842a.7.7 0 0 1 .418.897c-.615 1.69-2.155 2.52-3.646 2.544-1.485.025-3.04-.748-3.665-2.364a.7.7 0 0 1 1.306-.505c.374.967 1.32 1.486 2.335 1.47 1.009-.018 1.969-.564 2.354-1.623a.7.7 0 0 1 .897-.42M19 1.8a.7.7 0 0 1 .7.7v1.8h1.8a.7.7 0 0 1 0 1.4h-1.8v1.8a.7.7 0 1 1-1.4 0V5.7h-1.8a.7.7 0 1 1 0-1.4h1.8V2.5a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AddEmojiIcon24.js.map